export const USAGE_GUIDELINES_URL = 'https://help.telqtele.com/tp/usage-guidelines';
